import type {FormEvent} from 'react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {appPaths} from '@/config/appPaths';
import {authService} from '@/services/authService';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';

const useForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setEmail(event.target.value);
  };

  // Sends the reset code, then reuses the OTP screen, which signs the admin in
  // and continues to the set-password page.
  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    try {
      event.preventDefault();
      setIsLoading(true);
      const nonceResponse = await authService.requestPasswordReset({email});
      localStorage.setItem('nonce', nonceResponse.nonce);
      localStorage.setItem('logging-in', email);
      await navigate(`/${appPaths.verifyOtp}`, {
        replace: true,
        state: {from: {pathname: appPaths.setPassword}},
      });
    } catch (error) {
      setIsLoading(false);
      showErrorMessage(
        getErrorMessage(error, 'Error resetting password: Contact Engineering'),
      );
    }
  }

  return {
    handleChange,
    handleSubmit,
    isLoading,
  };
};
export type ForgotPasswordFormProps = ReturnType<typeof useForgotPassword>;

export default useForgotPassword;
